<div class="referral-input" *ngIf="referralLink">
    <input type="text" [value]="referralLink" readonly>
    <serviceos-ng-button *ngIf="moduleAccountTexts$ | async as moduleAccountTexts" [isAutoWidth]="true" [type]="'secondary'" (click)="copyText(referralLink)">{{ moduleAccountTexts.copy_button_title }}</serviceos-ng-button>
    <div class="copy-success-message" [ngClass]="{'copied': referralCopySuccess}">
        <serviceos-ng-alert [type]="'success'" *ngIf="moduleAccountTexts$ | async as moduleAccountTexts">{{ moduleAccountTexts.copy_button_label }}</serviceos-ng-alert>
    </div>
</div>